import React from "react";
import profile from '../asset/red.jpg';


const About = () => {

    return(
        <section id="about" className="py-20 bg-color1">
            
            <div className="">

            <div className="container mx-auto text-center px-6">
               <hr className="mb-20 h-1 bg-white rounded-full"/>
                <h1 className="text-4xl font-bold mb-8 text-black">About me</h1>

            <div className="flex flex-col items-center mb-12"> 
                <img src={`${profile}`} alt="picture profile" className="w-32 h-32 rounded-full object-cover mb-4 "/>
                <h1 className="text-3xl font-bold text-black mb-2">
                    Kidi Entern
                    </h1>
                <p className="text-xl text-black font-normal mb-9 ">
                    I’m an software engineer in KIDI  Telkom educorse
                </p>
                <div ></div>
                <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-3 gap-8" >
                    <div className="bg-white p-6 rounded-lg hover:bg-white transition-colors duration-300">
                        <h3 className="text-2xl font-bold m-4 text-black">React JS</h3>
                        <p className="text-lg text-black">React JS adalah framework JavaScript yang di gunakan untuk membangun interface pengguna yang interaktif</p>
                    </div>

                    <div className="bg-white p-6 rounded-lg hover:bg-white transition-colors duration-300">
                        <h3 className="text-2xl font-bold m-4 text-black">UI/UX</h3>
                        <p className="text-lg text-black">UI UX designer adalah seorang profesional yang bertanggung jawab untuk merancang antarmuka pengguna (UI) dan pengalaman pengguna (UX) pada produk atau aplikasi</p>
                    </div>

                    <div className="bg-white p-6 rounded-lg hover:bg-white transition-colors duration-300">
                        <h3 className="text-2xl font-bold m-4 text-black">Node JS</h3>
                        <p className="text-lg text-black">node.js adalah runtime environment untuk javascript yang bersifat open-source dan cross-platform</p>
                    </div>
                </div>
            </div>
            </div>
            </div>
        </section>
    )
} 
export default About;